
import './Styles/App.css';
import {
  BrowserRouter,
  BrowserRouter as Router,
} from 'react-router-dom';
import IndexRoutes from './Navigation/IndexRoutes';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import ScrollToTop from './Components/ScrollToTop';
import { useEffect } from 'react';
import { CountryDataWithCountryCode } from './utils/helperFunctions';
function App() {
  const dispatch = useDispatch()
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  
  useEffect(()=>{
    CountryDataWithCountryCode(dispatch)
  },[])

  return (
    <BrowserRouter>
      <ScrollToTop />
      <main>
        <Header />
        <IndexRoutes />
        <Footer />
      </main>
    </BrowserRouter>

  );
}

export default App;
